import type {
  ScoutApiResponse,
  ScoutBodyResponse,
  ScoutData,
  LikeData
} from '../types/scoutNotificationListPage';
import type { HistoryResponse } from '../types/applicationHistory'
import type { PersonShowResponse } from '../types/entries';
import type { ResponseUserDetails } from '../types/personShow';
import type { NotificationsAndUnreads, MarkReadAll } from '../types/personHeader';
import { wrapFetch } from '../libs/fetch';
import { RecommendRecruitments } from '../types/recruitments';

export const fetchScoutUnread = async (scoutId: number): Promise<ScoutApiResponse> => {
  return await wrapFetch<ScoutApiResponse>(`/api/v1/people/fetch_scout_unread?id=${scoutId}`);
};

export const fetchLikeUnread = async (likeId: number): Promise<ScoutApiResponse> => {
  return await wrapFetch<ScoutApiResponse>(`/api/v1/people/fetch_like_unread?id=${likeId}`);
};

export const fetchScoutBody = async (id: string | number): Promise<ScoutBodyResponse> => {
  return await wrapFetch<ScoutBodyResponse>(`/api/v1/people/fetch_scout_body?id=${id}`);
};

export const fetchScout = async (id: number): Promise<ScoutData> => {
  return await wrapFetch<ScoutData>(`/api/v1/people/fetch_scout?id=${id}`);
};

export const fetchLike = async (id: number): Promise<LikeData> => {
  return await wrapFetch<LikeData>(`/api/v1/people/fetch_like?id=${id}`);
};

export const fetchPerson = async (id: number): Promise<PersonShowResponse> => {
  return await wrapFetch<PersonShowResponse>(`/api/v1/people/${id}`);
};

export const createViaReact = async (req_body: any, csrfToken: string): Promise<{ message: string }> => {
  return await wrapFetch<{ message: string }>('/api/v1/people/create_via_react/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(req_body),
    credentials: 'same-origin',
  });
};

export const fetchUserDetails = async (personId: number) => {
  return await wrapFetch<ResponseUserDetails>(`/api/v1/people/get_user_details/${personId}`);
};

export const fetchNotifications = async () => {
  return await wrapFetch<NotificationsAndUnreads>('/api/v1/people/get_notifications');
};

export const fetchMarkReadAll = async () => {
  return await wrapFetch<MarkReadAll>('/api/v1/people/mark_read_all');
};

export const fetchHistory = async () => {
  return await wrapFetch<HistoryResponse>('/api/v1/people/history');
};

export const getRecommendRecruitments = async () => {
  return await wrapFetch<RecommendRecruitments>('/api/v1/people/get_recommend_recruitments');
};
